var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top relative overflow-hidden"},[_c('div',{staticClass:"top-text"},[_vm._v("我要用平台")]),_c('div',{staticClass:"titlebar absolute pin-b w-full text-center"},[_c('ButtonGroup',{},[_c('Button',[_vm._v("我要存储")]),_c('Button',[_vm._v("我要建设方案")]),_c('Button',[_vm._v("我要寻求帮助")])],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }